import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './Calendar.module.css';

/**
 * Individual calendar event component
 */
export const CalendarEvent = props => {
  const { event, onClick } = props;

  // Get status-based styling
  const getStatusClass = (status) => {
    switch (status) {
      case 'request':
      case 'preauthorized':
        return css.statusRequest;
      case 'accepted':
      case 'confirmed':
        return css.statusAccepted;
      case 'completed':
      case 'reviewed':
        return css.statusCompleted;
      case 'cancelled':
      case 'expired':
        return css.statusCancelled;
      default:
        return css.statusDefault;
    }
  };

  // Get status text
  const getStatusText = (status) => {
    switch (status) {
      case 'request':
      case 'preauthorized':
        return <FormattedMessage id="Calendar.status.request" defaultMessage="Request" />;
      case 'accepted':
      case 'confirmed':
        return <FormattedMessage id="Calendar.status.accepted" defaultMessage="Accepted" />;
      case 'completed':
      case 'reviewed':
        return <FormattedMessage id="Calendar.status.completed" defaultMessage="Completed" />;
      case 'cancelled':
      case 'expired':
        return <FormattedMessage id="Calendar.status.cancelled" defaultMessage="Cancelled" />;
      default:
        return status;
    }
  };

  // Format time for display
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const statusClass = getStatusClass(event.status);
  const statusText = getStatusText(event.status);
  const startTime = formatTime(event.start);
  const endTime = event.end ? formatTime(event.end) : null;

  return (
    <div 
      className={`${css.event} ${statusClass}`}
      onClick={onClick}
      title={`${event.title} - ${statusText} (${startTime}${endTime ? ` - ${endTime}` : ''})`}
    >
      <div className={css.eventTitle}>
        {event.title}
      </div>
      <div className={css.eventTime}>
        {startTime}
        {endTime && ` - ${endTime}`}
      </div>
      <div className={css.eventStatus}>
        {statusText}
      </div>
    </div>
  );
}; 